var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13.3039C4 10.6529 6.14904 8.50391 8.8 8.50391H31.2C33.851 8.50391 36 10.6529 36 13.3039V26.1039C36 28.7549 33.851 30.9039 31.2 30.9039H8.8C6.14904 30.9039 4 28.7549 4 26.1039V13.3039ZM8.8 11.7039C7.91635 11.7039 7.2 12.4203 7.2 13.3039V26.1039C7.2 26.9876 7.91635 27.7039 8.8 27.7039H31.2C32.0837 27.7039 32.8 26.9876 32.8 26.1039V13.3039C32.8 12.4203 32.0837 11.7039 31.2 11.7039H8.8Z",
    fill: "#AEB5C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3841 14.9044C26.8646 14.8996 27.3217 15.1109 27.6292 15.48L35.6292 25.08C36.195 25.7589 36.1033 26.7678 35.4244 27.3334C34.7455 27.8992 33.7366 27.8075 33.171 27.1286L26.4254 19.0339L21.2495 25.5038C20.7097 26.1787 19.7315 26.3029 19.0401 25.7843L13.7502 21.8169L8.33147 27.2357C7.70663 27.8605 6.69357 27.8605 6.06872 27.2357C5.44389 26.6109 5.44389 25.5977 6.06872 24.9729L12.4687 18.5729C13.0318 18.0099 13.9231 17.9465 14.5601 18.4243L19.7195 22.2939L25.1507 15.5048C25.4508 15.1296 25.9036 14.9092 26.3841 14.9044Z",
    fill: "#AEB5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPicture);
export default __webpack_public_path__ + "static/media/icon_picture.d9105752f293edbfd3b884084d91f176.svg";
export { ForwardRef as ReactComponent };